import { z } from "zod";
import { SYSTEM_FEATURES, SUPPORT_LEVELS, PLAN_TYPES } from "@fysaro/shared";

export const planConfigSchema = z.object({
  limits: z.object({
    maxPros: z.number().int(),
    maxServices: z.number().int(),
    maxClinics: z.number().int(),
    maxStorageGb: z.number(),
  }),
  features: z.array(z.enum(SYSTEM_FEATURES)).default([]),
  support: z.enum(SUPPORT_LEVELS).optional(),
});

export const planSchema = z.object({
  id: z.string().uuid(),
  type: z.enum(PLAN_TYPES), // El "ID lógico" (FREE, PREMIUM...)
  name: z.string().min(3), // El nombre comercial (ej: "Plan Pro Masajistas")
  description: z.string().nullable().optional(),
  //price: z.number().min(0).optional(),
  //stripePriceId: z.string().optional().nullable(),
  prices: z.record(
    z.string(), // moneda: "EUR", "USD", "GBP"
    z.object({
      amount: z.number().int().min(0).nullable(),
      stripePriceId: z.string().nullable(),
    }),
  ),
  interval: z.enum(["month", "year"]).default("month"),
  config: planConfigSchema,
  isActive: z.boolean().default(true),
  createdAt: z.date().or(z.string().datetime()),
});

// 2. ESQUEMA PARA CREAR (POST)
// Quitamos 'id' y 'createdAt' porque los pone el Backend/DB
export const createPlanSchema = planSchema.omit({
  id: true,
  createdAt: true,
});

// 3. ESQUEMA PARA EDITAR (PUT/PATCH)
// Hacemos que todo sea opcional pero mantenemos las validaciones
export const updatePlanSchema = createPlanSchema.partial();
